module.exports = __webpack_public_path__ + "static/media/20ECE25.ae872c42.jpg";